/**
 * Marks a product-zone value that is really the run's own text, shown because
 * the enriched field has not been written yet.
 *
 * Without it the reader would be quietly lying: the run's raw claim reads like
 * finished copy, and a developer judging the page would be judging the finder's
 * prose while believing they were looking at the refiner's.
 */
export function FromRunTag() {
  return <span className="gr-fromrun">from run</span>;
}
